export default __webpack_public_path__ + "static/media/Drizzle.43286041.svg";